module.exports = __webpack_public_path__ + "static/media/homebox.0e757035.svg";